import { parseCurrencyType, type CurrencyType } from '@/lib/currency'

/**
 * Betfair line session NE book display — Lab My PT `Rs.` / INR majors.
 *
 * Lab book calc is INR (`stake × rate`). Bet-list stake for POINTS uses Pts
 * (`betListMatchedAmt`); book tree stays INR majors — do **not** ÷100 here.
 *
 * - POINTS / POINT@1: show INR majors as-is (`alreadyDisplay`)
 * - INR: unchanged
 *
 * Match Odds / custom Fancy must not call this.
 */
export function lineSessionMoneyOpts(rawCurrency: string | undefined | null): {
  currency: CurrencyType
  alreadyDisplay: boolean
} {
  const raw = String(rawCurrency ?? 'INR')
    .trim()
    .toUpperCase()
  if (
    raw === 'POINTS' ||
    raw === 'POINT' ||
    raw === 'POINT@1' ||
    raw === 'POINT1' ||
    raw === 'POINT_AT_1'
  ) {
    return { currency: 'INR', alreadyDisplay: true }
  }
  return { currency: parseCurrencyType(raw), alreadyDisplay: false }
}
